import { ISystemModule } from 'interfaces/designOrchestration/designOrchestrationModules.interface';
import { IDesignOrchestrationDetailsContent } from 'interfaces/designOrchestration/designOrchestrationState.interface';

export enum VIEW_OPTIONS {
  COLUMN_VIEW = 'columnView',
  SPLIT_VIEW = 'splitView',
}

export const DESIGN_ORCHESTRATION_ACCORDION_HEADER_HEIGHT = 50;

const SELECT_NO_YES_PLACEHOLDER = 'Select No/Yes';

export const DESIGN_ORCHESTRATION_DETAILS_CONTENT: IDesignOrchestrationDetailsContent[] =
  [
    {
      id: 'orchestrationName',
      label: 'Orchestration name',
      maxLength: 255,
      placeholder: 'Enter the orchestration name',
      required: true,
      tooltip: 'The database constraint for this property is NVARCHAR(255).',
      type: 'text',
    },
    {
      id: 'orchestrationDescription',
      label: 'Orchestration Description',
      maxLength: 1000,
      placeholder: 'Describe the orchestration',
      required: false,
      tooltip: `The Orchestration description should be a single sentence beginning with a verb, e.g. "Imports documents to Apollo using Sync Import Service". 

The database constraint for this property is NVARCHAR(1000).`,
      type: 'textarea',
    },
    {
      id: 'businessProduct',
      label: 'Business Product',
      maxLength: 300,
      placeholder: 'Enter the business product name',
      required: false,
      tooltip: `This field helps distinguish role-specific permissions in BU Admin. 

The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'worker',
      label: 'Worker',
      maxLength: 300,
      placeholder: 'Enter the CSB Worker name',
      required: true,
      tooltip: `Enter the CSB Worker nameEnter the CSB Worker name, e.g. enter apacri for csb-worker-apacri. The CSB UI uses this value to allow you to see which Orchestrations in a CSB Worker use specific Modules. 

The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'throttleRate',
      label: 'Throttle Rate',
      maxLength: 300,
      placeholder: 'Enter an integer or leave blank',
      required: true,
      tooltip: `The Throttle Rate is the maximum number of product instances that can be executed simultaneously.
  
The property value must be an integer value or no value.`,
      type: 'number',
    },
    {
      id: 'cronTrigger',
      label: 'Cron Trigger',
      maxLength: 300,
      placeholder: 'Enter a valid cron expression like 0 0 * * *',
      required: false,
      tooltip: `The Cron Trigger defines the timestamp when the product instance should be triggered. 

It should contain a valid Cron expression. 
    
The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'cronTimezone',
      label: 'Cron Timezone',
      maxLength: 300,
      placeholder: 'Enter a valid timezone according to TimeZone.java',
      required: false,
      tooltip: `This optional property allows you to capture the Timezone in which the product instance should be triggered.

The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'sftpDropzone',
      label: 'SFTP Dropzone',
      maxLength: 300,
      placeholder: 'Enter SFTP dropzone name',
      required: false,
      tooltip: `Name of the SFTP dropzone from where the orchestration is triggered when a file is dropped for processing. 
    
The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'sftpPrivateKey',
      label: 'SFTP Private Key',
      maxLength: 300,
      placeholder: 'Enter SFTP Private Key',
      required: false,
      tooltip: `This is the SFTP private key that is used to authenticate a client when it connects to the SFTP server. 
    
The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'ftpDropzone',
      label: 'FTP Dropzone',
      maxLength: 300,
      placeholder: 'Enter FTP dropzone name',
      required: false,
      tooltip: `Name of the FTP dropzone from where the orchestration is triggered when a file is dropped for processing. 
    
The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 's3Dropzone',
      label: 'S3 Dropzone',
      maxLength: 300,
      placeholder: 'Enter S3 dropzone name',
      required: false,
      tooltip: `Name of the S3 dropzone from where the orchestration is triggered when a file is dropped for processing. 
    
The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 's3AccessKey',
      label: 'S3 Access Key',
      maxLength: 50,
      placeholder: 'Enter the AWS S3 Access Key',
      required: false,
      tooltip: `This property stores the AWS S3 Access Key. 
    
The property's database constraint is NVARCHAR(50).`,
      type: 'text',
    },
    {
      id: 's3PrivateKey',
      label: 'S3 Private Key',
      maxLength: 50,
      placeholder: 'Enter the AWS S3 Private Key',
      required: false,
      tooltip: `This property stores the AWS S3 Private Key. 
    
The property's database constraint is NVARCHAR(50).`,
      type: 'text',
    },
    {
      id: 'notificationEmails',
      label: 'Notification Emails',
      maxLength: 1000,
      placeholder: 'Enter email addresses to receive notifications',
      required: false,
      tooltip: `Enter email addresses that should receive notifications on completion of the product instance. 

Separate email addresses with commas when there are multiple recipients.

The database constraint for this property is NVARCHAR(1000).`,
      type: 'text',
    },
    {
      id: 'eventParamsMapping',
      label: 'Event Params Mapping',
      maxLength: 1000,
      placeholder: 'Enter eventParameterMapping string',
      required: false,
      tooltip: `This field is used by the Event Service, where Event Service parameters are mapped to module parameters. 

The database constraint for this property is NVARCHAR(1000).`,
      type: 'text',
    },
    {
      id: 'topicID',
      label: 'Topic ID',
      maxLength: 300,
      placeholder: 'Enter the Topic ID',
      required: false,
      tooltip: `This property must be populated when the Event Service is used.
      
It is the mapping between an event request and the submitted orchestration.

The CSB submits every orchestration with the given Topic ID.

The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'reportingIndex',
      label: 'Reporting Index',
      maxLength: 100,
      placeholder: 'Enter the reporting index predefined value',
      required: false,
      tooltip: `The reporting index is used to create a separate index for Elasticsearch when using the Reporting service. 

The database constraint for this property is NVARCHAR(100).`,
      type: 'text',
    },
    {
      id: 'tenant',
      label: 'Tenant',
      maxLength: 300,
      placeholder: 'Enter the tenant name',
      required: false,
      tooltip: `This property is an event-specific property used by the Event Service.

It is independent of the "worker" property, but is usually the same, e.g. Tenant="wkbe".

The database constraint for this property is NVARCHAR(300).`,
      type: 'text',
    },
    {
      id: 'timeoutAfternH',
      label: 'Timeout After nH',
      maxLength: 300,
      placeholder: 'Enter the timeout after n hours value',
      required: false,
      tooltip: `This property specifies the maximum number of hours an Orchestration instance should run, after which it is stopped automatically.

It is independent of the "worker" property, but is usually the same, e.g. Tenant="wkbe".

The database constraint for this property is INT`,
      type: 'number',
    },
    {
      id: 'unpackProduct',
      label: 'Unpack Product',
      placeholder: SELECT_NO_YES_PLACEHOLDER,
      required: false,
      tooltip: `Yes = (default value) when we have to unpack the input file for this product instance.

No = when we don't have to unpack the input file for this product instance.`,
      type: 'checkbox',
    },
    {
      id: 'supportsResubmit',
      label: 'Supports Resubmit',
      placeholder: SELECT_NO_YES_PLACEHOLDER,
      required: false,
      tooltip: `This property indicates when the Orchestration supports resubmit.

A developer should modify it after resubmission logic is implemented according to the "CSB Job Resubmit - LLD" low-level design in Confluence.

No = (default value) when the workflow doesn't support resubmission logic.

Yes = when the workflow supports resubmission logic.`,
      type: 'checkbox',
    },
    {
      id: 'supportsPrioritization',
      label: 'Supports Prioritization',
      placeholder: SELECT_NO_YES_PLACEHOLDER,
      required: false,
      tooltip: `This property indicates whether the additional popup is displayed when manually submitting an Orchestration instance, allowing the default priority to be overridden.

A user can enter the required priority on this screen before submitting the Orchestration instance.

No (default) = when we do not need to display a popup where the user can specify the priority on UI submit.

Yes = when we need to display a popup where the user can specify the priority on UI submit`,
      type: 'checkbox',
    },
  ];

export const DESIGN_ORCHESTRATION_SYSTEM_MODULES: Record<
  string,
  ISystemModule
> = {
  'system-aggregator': {
    iconName: 'wk-icon-contract-angle',
    label: 'Aggregate Batches',
    name: 'system-aggregator',
  },
  'system-filter': {
    iconName: 'wk-icon-funnel',
    label: 'Filter Contents',
    name: 'system-filter',
  },
  'system-noop': {
    iconName: 'wk-icon-arrow-down',
    label: 'Do Nothing',
    name: 'system-noop',
  },

  'system-splitter': {
    iconName: 'wk-icon-expand-angle',
    label: 'Split into Batches',
    name: 'system-splitter',
  },
};

export const DESIGN_ORCHESTRATION_MODULE_PARAMETERS_INFO: Record<
  string,
  Record<
    string,
    { defaultValue?: string; placeHolder: string; tooltip: string }
  >
> = {
  compare: {
    compareServicePlan: {
      defaultValue: '',
      placeHolder: 'Enter the Compare Service Plan Name',
      tooltip: `This field stores the Compare Service Plan Name.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    compareServiceUrl: {
      defaultValue: '',
      placeHolder: 'Enter the Compare Service endpoint',
      tooltip: `This property stores the Compare Service endpoint URL.
      
This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  conversion: {
    conversionMimetype: {
      defaultValue: 'application/zip',
      placeHolder: 'Enter the MIME type of the input file',
      tooltip: `This property field stores the input file's MIME type.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    conversionName: {
      defaultValue: '',
      placeHolder: 'Enter the Content Conversion Service Plan Name',
      tooltip: `This property stores the Content Conversion Service Plan Name.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    conversionVersion: {
      defaultValue: '',
      placeHolder: 'Enter the Content Conversion Plan Version Number',
      tooltip: `This property stores the version of the Content Conversion Service Plan being used.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    custom: {
      defaultValue: '',
      placeHolder: 'Enter any required key-value pairs',
      tooltip: `The property stores any key-value pairs needed by the Content Conversion Plan. Capture key-value pairs information in the following format:

key1=value1; key2=value2

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    endpointOSA3: {
      defaultValue: '',
      placeHolder: 'Enter the Content Conversion Service endpoint',
      tooltip: `This property stores the Content Conversion Service endpoint URL.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  'delete-service': {
    alfrescoSite: {
      defaultValue: '',
      placeHolder: 'Enter the Alfresco Site name',
      tooltip: `This property stores the Alfresco Site from where documents will be deleted.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    allegroRepository: {
      defaultValue: '',
      placeHolder: 'Enter the AllegroGraph Repository name',
      tooltip: `This property stores the AllegroGraph Repository name from where metadata will be deleted.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    deleteContent: {
      defaultValue: 'true',
      placeHolder: "Enter 'true' to delete the content",
      tooltip: `This Delete Service currently ignores this property, as content and metadata are deleted by default.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    deleteMetadata: {
      defaultValue: 'true',
      placeHolder: "Enter 'true' to delete the metadata",
      tooltip: `The Delete Service currently ignores this property, as content and metadata are deleted by default.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    deleteType: {
      defaultValue: '',
      placeHolder:
        'Enter the AllegroGraph delete type (HARD_DELETE or SOFT_DELETE)',
      tooltip: `This property determines how metadata is deleted from AllegroGraph

  HARD_DELETE = delete the graph from AllegroGraph.

  SOFT_DELETE = assign status = "statusDeleted" to the graph in AllegroGraph

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    documentURIs: {
      defaultValue: '',
      placeHolder: 'Enter the Document URIs',
      tooltip: `This property stores a comma-separated string containing the document URIs to delete.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    endpoint: {
      defaultValue: '',
      placeHolder: 'Enter the Delete Service endpoint',
      tooltip: `This property stores the Delete Service endpoint.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    failOnError: {
      defaultValue: 'true',
      placeHolder:
        "Enter 'true' or 'false' to determine the document's deletion status on 'error'",
      tooltip: `When a document returns an error, the Delete Service Module will fail or ignore the document's deletion status according to the value of this parameter.

  true = fail on error
  false = ignore on error

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    forceDelete: {
      defaultValue: 'false',
      placeHolder: "Enter 'true' to apply Force Delete",
      tooltip: `When a document's status in Alfresco is 'Locked', the value of this property determines what to do.

false = return a list of locked documents
true = check out all locked documents to allow them to be deleted.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    storeReport: {
      defaultValue: 'false',
      placeHolder: "Enter 'true' to generate a document status value report",
      tooltip: `When this property value is true, the Delete Service will create a report of document status values and save it into the DeleteReportHeader for further usage.
  
The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    tenant: {
      defaultValue: '',
      placeHolder: 'Enter the Alfresco Tenant name',
      tooltip: `This property stores the Alfresco Tenant's name.

This property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  delivery: {
    SASURI: {
      defaultValue: '',
      placeHolder: 'Enter the Azure Storage URI',
      tooltip: `This property stores the Azure Storage URI.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    accessKey: {
      defaultValue: '',
      placeHolder: 'Enter the AWS Access Key',
      tooltip: `This property stores the AWS Access Key.
The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    blobItemMaxAge: {
      defaultValue: '',
      placeHolder: 'Enter the Blob item maximum age',
      tooltip: `This property specifies the Time To Live (TTL) value for an uploaded file in Azure Blob Storage. The values are integers and in seconds. If no value is set in the backend, the value is set as 864000 = 10 days.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    bucket: {
      defaultValue: '',
      placeHolder: 'Enter the bucket name',
      tooltip: `This field contains the S3 bucket name/delivery path.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    cntAttempts: {
      defaultValue: '1',
      placeHolder: 'Enter the maximum number of delivery attempts',
      tooltip: `This property specifies the number of delivery attempts in case of failure.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    customRegion: {
      defaultValue: '',
      placeHolder: 'Enter the custom Region',
      tooltip: `This property stores the AWS Region to which content is delivered when the Custom S3 Endpoint is specified.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    customS3Endpoint: {
      defaultValue: '',
      placeHolder: 'Enter a custom S3 endpoint',
      tooltip: `This property stores a custom S3 endpoint URL if the default configuration of the current environment is insufficient.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    deliverTo: {
      defaultValue: 'S3',
      placeHolder: 'Enter the delivery destination type',
      tooltip: `This property determines the delivery destination type:

Direct path = delivers output to a local file system.

Path specified in dropZone
S3 = delivers to an S3 bucket
SFTP = delivers to SFTP
FTP = delivers to FTP
Azure Storage = delivers to Azure storage
AzureStorageAsync = delivers files to Azure Storage in parallel

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    deliveredFilesHeaderName: {
      defaultValue: '',
      placeHolder: 'Enter a bespoke delivered files header name, if needed',
      tooltip: `Where populated, this property specifies the Delivered Files Header Name to use in other modules.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    dropZone: {
      defaultValue: '',
      placeHolder: 'Enter the Drop Zone',
      tooltip: `This property stores the Drop Zone path.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    ftpFolder: {
      defaultValue: '',
      placeHolder: 'Enter the FTP Folder',
      tooltip: `This property stores the FTP Folder name on the server.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    ftpHost: {
      defaultValue: '',
      placeHolder: 'Enter the FTP Host',
      tooltip: `This property stores the FTP Host path.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    ftpLogin: {
      defaultValue: '',
      placeHolder: 'Enter the FTP Login',
      tooltip: `This property stores the FTP Login credentials.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    ftpPassword: {
      defaultValue: '',
      placeHolder: 'Enter the FTP Password',
      tooltip: `This property stores the FTP Password.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    ftpPort: {
      defaultValue: '22',
      placeHolder: 'Enter the FTP Port',
      tooltip: `This property stores the FTP Port.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    privateKey: {
      defaultValue: '',
      placeHolder: 'Enter the AWS Private Key',
      tooltip: `This property stores the AWS Private Key.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    secAttemptsGap: {
      defaultValue: '10',
      placeHolder: 'Enter the time gap between delivery attempts',
      tooltip: `This property specifies the interval in seconds between delivery attempts.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpDropZone: {
      defaultValue: '',
      placeHolder: 'Enter the SFTP Dropzone',
      tooltip: `This property stores the SFTP Dropzone path.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpLogin: {
      defaultValue: '',
      placeHolder: 'Enter the SFTP Login',
      tooltip: `This property stores the SFTP Login.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpPassPhrase: {
      defaultValue: '',
      placeHolder: 'Enter the SFTP Pass Phrase',
      tooltip: `This property stores the SFTP Pass Phrase.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpPassword: {
      defaultValue: '',
      placeHolder: 'Enter the SFTP Password',
      tooltip: `This property stores the SFTP Password.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpPort: {
      defaultValue: '22',
      placeHolder: 'Enter the SFTP Port',
      tooltip: `This property stores the SFTP Port.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sftpPrivateKey: {
      defaultValue: '',
      placeHolder: 'Enter the SFTP Private Key',
      tooltip: `This property stores the SFTP Private Key, which is used with the sftpPassPhrase instead of the sftpPassword.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sharedAccessSignatureURI: {
      defaultValue: '',
      placeHolder: 'Enter the Shared Access Signature URI.',
      tooltip: `This property stores the Azure Storage URI where AzureStorageAsync is used.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    useDefaultProviderChain: {
      defaultValue: 'False',
      placeHolder: "Enter 'true' to use the DefaultAWSCredentialsProviderChain",
      tooltip: `This property determines which access credentials to retrieve:

false = use the access key and private key credentials
true = use DefaultAWSCredentialsProviderChain to get credentials

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  enrichment: {
    customProperties: {
      defaultValue: '',
      placeHolder: 'Enter the key-value pairs',
      tooltip: `This property stores any key-value pairs needed by the Enrichment Plan. Capture this information in the following format: key1=value1; key2=value2

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    domain: {
      defaultValue: 'Enrichment',
      placeHolder: 'Enter the OSA Domain name',
      tooltip: `This property stores the OSA Domain Name. 'enrichment' is the only domain value option available.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    endpoint: {
      defaultValue: '',
      placeHolder: 'Enter the Content Enrichment endpoint',
      tooltip: `This property stores the Content Enrichment service endpoint URL.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    enrichmentPlan: {
      defaultValue: '',
      placeHolder: 'Enter the name of the Enrichment Plan to use',
      tooltip: `This property stores the name of the Enrichment Plan for use by the Enrichment Service.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    enrichmentPlanVersion: {
      defaultValue: '',
      placeHolder: 'Enter the version of the Enrichment Plan to use',
      tooltip: `This property stores the version of the Enrichment Plan to use in the Enrichment Service.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    inputContentType: {
      defaultValue: 'application/xml',
      placeHolder: 'Enter the MIME type of the input file',
      tooltip: `This property stores the MIME type of the input file.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    inputMetadataType: {
      defaultValue: 'text/turtle',
      placeHolder: 'Enter the MIME type of the input metadata file',
      tooltip: `This property stores the MIME type of the input metadata file.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    outputContentType: {
      defaultValue: 'application/xml',
      placeHolder: 'Enter the MIME type of the output file',
      tooltip: `This property stores the MIME type of the output file.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    outputMetadataType: {
      defaultValue: 'application/rdf+xml',
      placeHolder: 'Enter the MIME type of the output metadata file',
      tooltip: `This property stores the MIME type of the output metadata file.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  export: {
    custom: {
      defaultValue: '',
      placeHolder: 'Enter the key-value pairs',
      tooltip: `The property stores any key-value pairs needed by the Export Service Plan. Capture key-value pairs information in the following format: key1=value1; key2=value2

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    documents: {
      defaultValue: '',
      placeHolder: 'Enter document URIs to export',
      tooltip: `This property stores the list of comma-separated document URIs to export.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    endpoint: {
      defaultValue: '',
      placeHolder: 'Enter the Export Service endpoint',
      tooltip: `This property stores the Export Service endpoint URL.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    packageInformation: {
      defaultValue: 'false',
      placeHolder: "Enter 'true' to include package info in CSB header",
      tooltip: `This property value determines whether information about the package is added to the CSB header.

true = Updates hasAssets CSB header if output PCI package contains attachments. Updates pciDocsCount CSB header with number of documents in the PCI output package.
Boolean

Updates hasAssets CSB header - sets true if output pci package contains attachments.

Updates pciDocsCount CSB header - sets number of documents in output pci package.`,
    },
    provider: {
      defaultValue: 'alfresco',
      placeHolder: 'Enter the Provider name (Alfresco | AGraph)',
      tooltip: `This property stores the Export Service Provider name, which is preconfigured on the Export Service side. It can be Alfresco or AGraph.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    tenant: {
      defaultValue: '',
      placeHolder: 'Enter the Alfresco Tenant name',
      tooltip: `This property stores the Tenant name, which is preconfigured on the Export Service side.

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
  validation: {
    continueIfFailed: {
      defaultValue: 'false',
      placeHolder: "Enter 'true' to continue the flow if validation fails",
      tooltip: `This property defines whether to stop a flow if validation fails. 

false = the flow stops if validation fails (default value) true = the flow continues if validation fails. 

The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    endpointOSA3: {
      defaultValue: 'http://10.232.41.72:8480/content-validation-odata-war/',
      placeHolder: 'Enter the Validation Service endpoint',
      tooltip: `This property stores the Validation service endpoint. The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    sendReport: {
      defaultValue: 'false',
      placeHolder:
        "Enter 'true' to put all reports with 'ERROR' status into the 'CSBEmailBody' header",
      tooltip: `This property defines whether to put all reports with 'ERROR' status into the 'CSBEmailBody'
      
header false = do not put all reports with 'ERROR' status into the 'CSBEmailBody' 
      
header (default value) true = put all reports with 'ERROR' status into the 'CSBEmailBody' header. 
      
The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    usePackaging: {
      defaultValue: 'false',
      placeHolder: "Enter 'true' if the content should be zipped",
      tooltip: `This property defines whether to zip content. 
      
false = if the content is not zipped (default value) true = if the content should be zipped. 
      
The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    validationMimetype: {
      defaultValue: '',
      placeHolder: 'Enter the content input MIME type',
      tooltip: `This property defines the MIME type of the content input being validated. 
      
The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    validationName: {
      defaultValue: '',
      placeHolder: 'Enter the Validation Plan name',
      tooltip: `This property stores the Validation Plan name. The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
    validationVersion: {
      defaultValue: '',
      placeHolder: 'Enter the Validation Plan version',
      tooltip: `This property defines the Validation Plan version number. The property's database constraint is MEDIUMTEXT (up to 16 MB).`,
    },
  },
};

export const DESIGN_ORCHESTRATION_MODULES_PANEL_WIDTH = 328;
export const DESIGN_ORCHESTRATION_XML_PANEL_WIDTH = 368;
export const MODULES_NEEDING_ESCAPE_CHARACTERS = ['publish-event'];
